"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWrapper = IconWrapper;

var _react = _interopRequireDefault(require("react"));

var _config = require("./config");

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function IconWrapper(type, Component) {
  return function (props) {
    var _classnames;

    var defaultConfig = (0, _config.getConfig)();

    var _props$theme = props.theme,
        theme = _props$theme === void 0 ? defaultConfig.theme : _props$theme,
        _props$size = props.size,
        size = _props$size === void 0 ? defaultConfig.size : _props$size,
        _props$fill = props.fill,
        fill = _props$fill === void 0 ? 'currentColor' : _props$fill,
        _props$strokeLinecap = props.strokeLinecap,
        strokeLinecap = _props$strokeLinecap === void 0 ? defaultConfig.strokeLinecap : _props$strokeLinecap,
        _props$strokeLinejoin = props.strokeLinejoin,
        strokeLinejoin = _props$strokeLinejoin === void 0 ? defaultConfig.strokeLinejoin : _props$strokeLinejoin,
        _props$strokeWidth = props.strokeWidth,
        strokeWidth = _props$strokeWidth === void 0 ? defaultConfig.strokeWidth : _props$strokeWidth,
        className = props.className,
        _props$spin = props.spin,
        spin = _props$spin === void 0 ? false : _props$spin,
        extra = _objectWithoutProperties(props, ["theme", "size", "fill", "strokeLinecap", "strokeLinejoin", "strokeWidth", "className", "spin"]);

    var colors = Array.isArray(fill) ? fill : [fill];
    var config;

    switch (theme) {
      case 'outline':
        config = {
          size: size,
          strokeLinecap: strokeLinecap,
          strokeLinejoin: strokeLinejoin,
          strokeWidth: strokeWidth,
          outStrokeColor: colors[0],
          outFillColor: 'transparent',
          innerStrokeColor: colors[0],
          innerFillColor: 'transparent'
        };
        break;

      case 'filled':
        config = {
          size: size,
          strokeLinecap: strokeLinecap,
          strokeLinejoin: strokeLinejoin,
          strokeWidth: strokeWidth,
          outStrokeColor: colors[0],
          outFillColor: colors[0],
          innerStrokeColor: '#FFF',
          innerFillColor: '#FFF'
        };
        break;

      case 'two-tone':
        config = {
          size: size,
          strokeLinecap: strokeLinecap,
          strokeLinejoin: strokeLinejoin,
          strokeWidth: strokeWidth,
          outStrokeColor: colors[0],
          outFillColor: colors[1] || defaultConfig.outFillColor,
          innerStrokeColor: colors[0],
          innerFillColor: colors[1] || defaultConfig.outFillColor
        };
        break;

      default:
        config = {
          size: size,
          strokeLinecap: strokeLinecap,
          strokeLinejoin: strokeLinejoin,
          strokeWidth: strokeWidth,
          outStrokeColor: colors[0],
          outFillColor: colors[1] || defaultConfig.outFillColor,
          innerStrokeColor: colors[2] || defaultConfig.innerStrokeColor,
          innerFillColor: colors[3] || defaultConfig.innerFillColor
        };
    }

    var prefix = defaultConfig.prefix;
    var cls = (0, _util.classnames)((_classnames = {}, _defineProperty(_classnames, "".concat(prefix, "-icon"), true), _defineProperty(_classnames, "".concat(prefix, "-icon-").concat(type), true), _defineProperty(_classnames, "".concat(prefix, "-icon-spin"), spin && type !== 'loading'), _classnames), defaultConfig.extraClassName, className);
    return _react.default.createElement("span", Object.assign({}, extra, {
      className: cls
    }), _react.default.createElement(Component, Object.assign({}, config)));
  };
}